/* eslint-disable react/display-name */
import PostCard from 'components/PostCard';
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { intl } from 'components/LocaleProvider';
import PropTypes from 'prop-types';
import { useAuth } from 'root/hooks/useAuth';
import messages from './messages';
import apiClient from '../../lib/apiClient';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const LatestPosts = ({ posts = [] }) => {
  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  return (
    <React.Fragment>
      {posts.length !== 0 && (
        <React.Fragment>
          <hr />
          <div className="section-title align-center transparent-border">
            <span className="label">{intl.formatMessage(messages.interestingArticles)}</span>
          </div>
          <section id="latest-posts-widget" className="widget author-page">
            <div className="posts-row">
              {posts?.map((post) => (
                <PostCard
                  key={post.id}
                  post={post}
                  isAuthenticated={isAuthenticated}
                  bookmarks={bookmarks}
                  handleBookmarks={setBookmarks}
                />
              ))}
            </div>
          </section>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

LatestPosts.propTypes = {
  posts: PropTypes.array,
};

export default LatestPosts;
